import { useGetVideosQuery } from "@features/videos/videosApi";
import CourseItem from "./CourseItem";

const CourseList = () => {
  const { data: videos, isLoading, isError } = useGetVideosQuery();

  // decide what to render
  let content = "";

  if (isLoading) {
    content = <div className="text-center">Loading...</div>;
  }

  if (!isLoading && isError) {
    content = (
      <div className="text-center text-red-500">Internal server error!</div>
    );
  }

  if (!isLoading && !isError && videos?.length === 0) {
    content = <div className="text-center">No videos found!</div>;
  }

  if (!isLoading && !isError && videos?.length > 0) {
    content = videos.map((video) => (
      <CourseItem key={video.id} video={video} />
    ));
  }

  return (
    <div className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">
      {content}
    </div>
  );
};

export default CourseList;
